export default __webpack_public_path__ + "static/media/Dedicated.d9b5be75.png";